export const localStatusToGraphqlStatus = (status: string): string[] => {
  switch (status) {
    case 'DRAFT':
      return ['DRAFT'];
    case 'PENDING':
      return ['PENDING'];
    case 'WAITLIST':
      return ['WAITLIST'];
    case 'CONFIRMED':
      return ['CONFIRMED'];
    case 'REJECTED':
      return ['REJECTED', 'RETRY'];
    case 'ALL':
    default:
      return ['PENDING', 'WAITLIST', 'CONFIRMED', 'REJECTED', 'RETRY'];
  }
};

export const HUB_COUNTER_SORT_OPTIONS = [
  { value: 'createdAt', label: 'Erstellt am' },
  { value: 'updatedAt', label: 'Zuletzt aktualisiert' },
  { value: 'amazonVerifiedAt', label: 'Amazon verifiziert am' },
  { value: 'rejectionTimestamp', label: 'Abgelehnt am' },
  { value: 'hubCounterID', label: 'Hub Counter ID' },
  { value: 'status', label: 'Status' },
];

export type HubCounterSortField = (typeof HUB_COUNTER_SORT_OPTIONS)[number]['value'];
